import React from 'react';
import FastClone from 'fastest-clone';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Alert from '../components/Alert';

export default class AlertModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.makeState();
    this.alert = null;
    window.page.modal = this;
  }

  show = (e) => {

    this.alert = e != null ? e :
      new Alert({});

    var s = this.makeState();
    s.modal = true;
    s.form.name = this.alert.state.Name;
    s.form.code = this.alert.state.Code;
    s.form.interval = this.alert.state.Interval;
    s.form.enabled = this.alert.state.Enabled;
    this.setState(s);

  }

  hide = (e) => {
    var s = this.makeState();
    s.modal = false;
    this.setState(s);
  }

  save = (e) => {
    var self = this;
    this.alert.save(
      this.state.form.name,
      this.state.form.code,
      this.state.form.interval,
      this.state.form.enabled
    ).then(function () {
      window.page.list.loadAlerts();
      self.hide();
    });
  }

  onNameChange = (e) => {
    var s = this.makeState();
    s.form.name = e.target.value;
    this.setState(s);
  }

  onCodeChange = (e) => {
    var s = this.makeState();
    s.form.code = e.target.value;
    this.setState(s);
  }

  onIntervalChange = (e) => {
    var s = this.makeState();
    s.form.interval = parseInt(e.target.value, 10);
    this.setState(s);
  }

  onEnabledChange = (e) => {
    var s = this.makeState();
    s.form.enabled = e.target.checked;
    this.setState(s);
  }

  makeState() {
      var s = {};

      if (this.state == null) {
        s.modal = false;
        s.form = {};
        s.form.name = '';
        s.form.interval = 0;
        s.form.code = '';
        s.form.enabled = true;
      } else {
        s = new (FastClone.factory(this.state, true))(this.state);
      }

      return s;
  }

  render() {
    return (
    <Modal isOpen={this.state.modal} className={this.props.className}>
        <ModalHeader>Configurar Alerta</ModalHeader>
        <ModalBody>
            <div className="form-group">
                <label>Nome:</label>
                <input onChange={this.onNameChange} value={this.state.form.name} type="text" className="form-control" />
            </div>
            <div className="form-group">
                <label>Código (C#):</label>
                <textarea onChange={this.onCodeChange} value={this.state.form.code} className="form-control" rows="10"></textarea>
            </div>
            <div className="form-group row">
                <div className="col-md-6">
                    <label>Intervalo (seg):</label>
                    <input onChange={this.onIntervalChange} value={this.state.form.interval} type="text" className="form-control" />
                </div>
                <div className="col-md-6">
                    <div className="align-bottom">
                        <input onChange={this.onEnabledChange} checked={this.state.form.enabled} type="checkbox" />
                        <label>Habilitado</label>
                    </div>
                </div>
            </div>
        </ModalBody>
        <ModalFooter>
        <Button color="primary" onClick={this.save}>Salvar</Button>{' '}
        <Button color="secondary" onClick={this.hide}>Cancelar</Button>
        </ModalFooter>
    </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AlertModal.js